// src/components/quizzes/kit/BonusEndEarly.js
//
// "🏁 End game" for the bonus rounds. Tapping it asks first (a stray tap on a
// smart board shouldn't end the round); "Yes, end it" finishes the round
// with the points so far. Ending early keeps the score but NOT the star —
// the parent gets onBonusComplete(score, { endedEarly: true }) and
// UniversalQuizGame then saves the scores without marking the game done.
//
//   <BonusEndEarly onEnd={() => finish(true)} onPause={setPaused} />

import React, { useState } from "react";
import "./bonusShell.css";

const BonusEndEarly = ({ onEnd, onPause, disabled = false }) => {
  const [asking, setAsking] = useState(false);
  const ask = (v) => {
    setAsking(v);
    onPause?.(v);
  };
  return (
    <>
      <button type="button" className="bs-end-btn" onClick={() => ask(true)} disabled={disabled} aria-label="End the bonus round now">
        🏁 End game
      </button>
      {asking && (
        <div className="bs-end-ask" role="dialog" aria-modal="true" aria-label="End the bonus round?">
          <div className="bs-end-card">
            <div className="bs-end-emoji">🏁</div>
            <div className="bs-end-title">End the bonus round now?</div>
            <p className="bs-end-text">
              You keep all your points! But the <b>⭐ star</b> is only for playing the whole round.
            </p>
            <div className="bs-end-actions">
              <button type="button" className="bs-end-keep" onClick={() => ask(false)} autoFocus>
                Keep playing
              </button>
              <button
                type="button"
                className="bs-end-yes"
                onClick={() => {
                  setAsking(false);
                  onPause?.(false);
                  onEnd?.();
                }}
              >
                Yes, end it
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BonusEndEarly;
